import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { SkillsExplorer } from '../components/SkillsExplorer';
export function Skills() {
  return <>
      <PageHeader eyebrow="Skills & Endorsements" title="Competencies validated by senior peers across defense, government and industry." intro="Filter by industry knowledge, interpersonal skills or business strategy to see where each competency was exercised and who endorsed it." data-id="element-321" data-mp="e7a9oxs2kze3" />
      <SkillsExplorer data-id="element-322" data-mp="wvfd244teicd" />
    </>;
}